import request from '../../../api/request';

import {
  StudentFileFormDataResponse,
  StudentFilePostulantRequest,
} from './types';

const STUDENT_FILE = {
  GET_POSTULANTS: 'teacher-portal/student-file',
  GET_FORM_DATA: 'teacher-portal/student-file/form',
};

export const getFormData = () => {
  return request<StudentFileFormDataResponse>(STUDENT_FILE.GET_FORM_DATA);
};

export const getPostulants = (params: StudentFilePostulantRequest) => {
  return request(STUDENT_FILE.GET_POSTULANTS, {
    params,
  });
};
